<template>
  <div>
    <el-form ref="form" :rules="rules" :model="form" label-width="190px">
      <el-row>
        <el-col :span="24">
          <el-form-item label="上传证件">
            <el-checkbox
              v-if="checkQuire"
              v-model="requireData.identificationImg"
              style="margin-right: 10px"
              :true-label="1"
              :false-label="0"
            />
            <ImgUpload
              :upload-config="{
                lebal: '身份证人像面照片',
                prefix: 'identification',
                form: form,
                suffix: 'Img'
              }"
              :required="!!requireData.identificationImg"
              @handleImgSuccess="ficationImgSuccess"
            />
            <el-checkbox
              v-if="checkQuire"
              v-model="requireData.identificationBackImg"
              style="margin-right: 10px"
              :true-label="1"
              :false-label="0"
            />
            <ImgUpload
              :upload-config="{
                lebal: '身份证国徽面照片',
                prefix: 'identificationBack',
                form: form,
                suffix: 'Img'
              }"
              :required="!!requireData.identificationBackImg"
              @handleImgSuccess="ficationImgBackSuccess"
            />
            <el-checkbox
              v-if="checkQuire"
              v-model="requireData.businessLicenseImg"
              style="margin-right: 10px"
              :true-label="1"
              :false-label="0"
            />
            <ImgUpload
              :upload-config="{
                lebal: '统一社会信用代码照片',
                prefix: 'businessLicense',
                form: form,
                suffix: 'Img'
              }"
              :required="!!requireData.businessLicenseImg"
              @handleImgSuccess="businessImgSuccess"
            />
            <el-checkbox
              v-if="checkQuire"
              v-model="requireData.roadPermitNumberImg"
              style="margin-right: 10px"
              :true-label="1"
              :false-label="0"
            />
            <ImgUpload
              :upload-config="{
                lebal: '道路运输经营许可证照片',
                prefix: 'roadPermitNumber',
                form: form,
                suffix: 'Img'
              }"
              :required="!!requireData.roadPermitNumberImg"
              @handleImgSuccess="roadPermitNumberSuccess"
            />
            <el-checkbox
              v-if="checkQuire"
              v-model="requireData.safeDutyInsureImg"
              style="margin-right: 10px"
              :true-label="1"
              :false-label="0"
            />
            <ImgUpload
              :upload-config="{
                lebal: '安全责任险照片',
                prefix: 'safeDutyInsure',
                form: form,
                suffix: 'Img'
              }"
              :required="!!requireData.safeDutyInsureImg"
              :parent-data="parentData"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.linkMan"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('linkMan')"
          />
          <el-form-item label="车队名称" prop="linkMan">
            <el-input
              v-model.trim="form.linkMan"
              placeholder="请输入车队名称"
              @keydown.native="channelInputLimit"
            />
          </el-form-item>
        </el-col>
        <!-- <el-col :span="6">
          <el-form-item label="性别" prop="sex">
            <el-select v-model="form.sex" placeholder="请选择性别" clearable>
              <el-option value="1" label="男"></el-option>
              <el-option value="2" label="女"></el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
        <el-col :span="6">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.name"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('name')"
          />
          <el-form-item label="联系人" prop="name" label-width="120px">
            <el-input
              v-model.trim="form.name"
              placeholder="请输入联系人"
              @keydown.native="channelInputLimit"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!-- <el-checkbox v-if="checkQuire" :true-label="1" :false-label="0" class="bigCheckBox" @change="setQuired('phone')" v-model="requireData.phone"></el-checkbox> -->
          <el-form-item label="联系方式" prop="phone">
            <el-input
              v-model="form.phone"
              placeholder="请输入联系方式"
              autocomplete="off"
            />
          </el-form-item>
        </el-col>
        <el-col v-if="isAdmin" :span="12">
          <el-form-item label="是否清分" prop="isShare">
            <el-select v-model="form.isShare">
              <el-option
                v-for="item in isShareOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.password"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('password')"
          />
          <el-form-item label="密码" prop="password">
            <el-input
              v-model="form.password"
              type="password"
              autocomplete="new-password"
              placeholder="请输入密码，默认abcd1234"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            v-if="compIsShare && isAdmin"
            label="清分比率(%)"
            prop="shareRatio"
          >
            <el-input
              v-model="form.shareRatio"
              placeholder="请输入0-100的正整数"
              @input="
                value =>
                  formFormatter.ishundredInteger(
                    value,
                    oldValue,
                    form,
                    'shareRatio'
                  )
              "
            />
          </el-form-item>
        </el-col>
        <!-- <el-col :span="12">
          <el-form-item label="车队名称1" prop="linkMan">
            <el-input
              v-model.trim="form.linkMan"
              @keydown.native="channelInputLimit"
              placeholder="请输入车队名称"
            />
          </el-form-item>
        </el-col> -->
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.workCompany"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('workCompany')"
          />
          <el-form-item label="工作单位" prop="workCompany">
            <el-input v-model="form.workCompany" placeholder="请输入工作单位" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.areaList"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('areaList')"
          />
          <el-form-item label="通信地址" prop="areaList">
            <el-cascader
              v-model="form.areaList"
              placeholder="请选择通信地址"
              :options="parentData.areaOptions"
              :props="{
                value: 'countyCode',
                label: 'countyName',
                children: 'children'
              }"
              @change="changeAreaList"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.homeAddress"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('homeAddress')"
          />
          <el-form-item label="详细地址" prop="homeAddress">
            <el-input v-model="form.homeAddress" placeholder="请输入详细地址" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.legalPerson"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('legalPerson')"
          />
          <el-form-item label="法人代表名称" prop="legalPerson">
            <el-input
              v-model.trim="form.legalPerson"
              placeholder="请输入法人代表名称"
              @change="
                value => {
                  form.legalPerson = value.replace(/\s/g, '');
                }
              "
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.identificationNumber"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('identificationNumber')"
          />
          <el-form-item label="身份证号" prop="identificationNumber">
            <el-input
              v-model="form.identificationNumber"
              placeholder="请输入身份证号"
            />
          </el-form-item>
        </el-col>
        <el-col :span="checkQuire ? 12 : 9">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.idCardDueDate"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('idCardDueDate')"
          />
          <el-form-item label="身份证有效期" prop="idCardDueDate">
            <el-date-picker
              v-model="form.idCardDueDate"
              :class="form.hasDueDate ? 'disabledhide' : ''"
              type="date"
              placeholder="请选择身份证有效期"
              value-format="yyyy-MM-dd"
              clearable
              :disabled="form.hasDueDate"
            />
          </el-form-item>
        </el-col>
        <el-col v-if="!checkQuire" :span="3">
          <el-form-item label="长期" label-width="60px">
            <el-checkbox
              v-model="form.hasDueDate"
              @change="
                value => {
                  this.$set(form, 'idCardDueDate', value ? '9999-12-31' : '');
                }
              "
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.roadPermitNumber"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('roadPermitNumber')"
          />
          <el-form-item label="道路运输经营许可证号" prop="roadPermitNumber">
            <el-input
              v-model="form.roadPermitNumber"
              placeholder="请输入道路运输经营许可证号"
              @change="
                value => {
                  form.roadPermitNumber = value.replace(/\W/g, '');
                }
              "
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-checkbox
            v-if="checkQuire"
            v-model="requireData.businessLicenseNumber"
            :true-label="1"
            :false-label="0"
            class="bigCheckBox"
            @change="setQuired('businessLicenseNumber')"
          />
          <el-form-item label="统一社会信用代码" prop="businessLicenseNumber">
            <el-input
              v-model="form.businessLicenseNumber"
              placeholder="请输入统一社会信用代码"
              @change="
                value => {
                  form.businessLicenseNumber = value.replace(/\W/g, '');
                }
              "
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="允许实际承运人抢单" prop="allowDriverReceive">
            <el-select v-model="form.allowDriverReceive">
              <el-option
                v-for="item in allowDriverReceiveOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-button
      v-if="!checkQuire"
      type="primary"
      plain
      @click="funcSubmit('form')"
    >
      提交
    </el-button>
    <el-button
      v-if="checkQuire && isAdmin"
      type="primary"
      plain
      @click="funcSaveSet()"
    >
      保存必填设置
    </el-button>
  </div>
</template>
<script>
import { addDriverTeam } from "@/api/driver";
import { validatePhone, validateIDNumber } from "@/utils/validate.js";
import { isPersonName } from "@/utils/validate4Form";
import { findByFieldFrom, updateFieldRequired } from "@/api/required";
import { getOcr } from "@/api/shipment";
import {
  ishundredInteger,
  checkPassword,
  isBusinessLicenseImgNum
} from "@/utils/validate4Form.js";
import ImgUpload from "@/components/ImgUpload";
import { realDay } from "@/utils/validate";
export default {
  name: "DriverTeamAdd",
  components: {
    ImgUpload
  },
  props: {
    parentData: {
      type: Object,
      default() {
        return {
          areaOptions: [],
          vehicleBindList: [],
          vehicleTypeAllowList: [],
          vehicleLengthList: [],
          vehicleWidthList: [],
          vehicleHighList: [],
          vehicleTonnageList: [],
          locationSourceList: []
        };
      }
    }
  },
  data() {
    return {
      value1: "",
      form: {
        linkMan: "",
        name: "",
        phone: "",
        password: "",
        identificationNumber: "",
        areaList: [],
        provinceCode: "",
        cityCode: "",
        countyCode: "",
        homeAddress: "",
        legalPerson: "",
        workCompany: "",
        businessLicenseNumber: "",
        roadPermitNumber: "",
        identificationImg: "",
        identificationBackImg: "",
        businessLicenseImg: "",
        roadPermitNumberImg: "",
        driverType: "1",
        sex: "1",
        shareRatio: "",
        isShare: 0,
        allowDriverReceive: 0
      },
      // 是否清分
      isShareOptions: [{ label: "否", value: 0 }, { label: "是", value: 1 }],
      // 允许抢单
      allowDriverReceiveOptions: [
        { label: "允许", value: 0 },
        { label: "禁止", value: 1 }
      ],
      // 必填功能
      checkQuire: false,
      isAdmin: false,
      requireData: {},
      rules: {
        areaList: [
          { required: false, message: "请选择所在区域", trigger: "change" }
        ],
        homeAddress: [
          { required: false, message: "请输入详细地址", trigger: "blur" },
          { max: 255, message: "最大长度为255个字符" }
        ],
        identificationNumber: [
          {
            required: false,
            message: "请输入身份证号",
            trigger: "blur"
          },
          {
            validator(rule, value, callback) {
              validateIDNumber(value)
                ? callback()
                : callback(new Error("请输入正确的身份证号"));
            },
            trigger: "blur"
          }
        ],
        idCardDueDate: [
          {
            required: false,
            message: "请选择身份证有效期",
            trigger: "change"
          }
        ],
        linkMan: [
          { required: false, message: "请输入车队名称", trigger: "blur" },
          { max: 64, message: "最大长度为64个字符" },
          { validator: isPersonName }
        ],
        name: [
          { required: false, message: "请输入联系人", trigger: "blur" },
          { max: 64, message: "最大长度为64个字符" },
          { validator: isPersonName }
        ],
        password: [
          { required: false, message: "请输入密码", trigger: "blur" },
          { validator: checkPassword }
        ],
        shareRatio: [
          { required: true, message: "请输入清分比率(%)", trigger: "blur" },
          { validator: ishundredInteger }
        ],
        phone: [
          {
            required: true,
            validator(rule, value, callback) {
              validatePhone(value)
                ? callback()
                : callback(new Error("请输入正确的联系方式"));
            },
            trigger: "blur"
          }
        ],
        businessLicenseNumber: [
          {
            required: false,
            message: "请输入统一社会信用代码",
            trigger: "blur"
          },
          { validator: isBusinessLicenseImgNum }
        ],
        roadPermitNumber: [
          {
            required: false,
            message: "请输入道路运输经营许可证号",
            trigger: "blur"
          },
          { max: 128, message: "最大长度为128个字符" }
        ],
        legalPerson: [
          { required: false, message: "请输入法人代表名称", trigger: "blur" },
          { max: 64, message: "最大长度为64个字符" }
        ],
        workCompany: [
          { required: false, message: "请输入工作单位", trigger: "blur" },
          { max: 255, message: "最大长度为255个字符" }
        ]
      }
    };
  },
  computed: {
    compIsShare() {
      return this.form.isShare == 1 ? true : false;
    }
  },
  watch: {
    // compIsShare(newValue, oldValue) {
    //   let Blen = !!newValue?false:!!this.requireData.roadPermitNumber
    //   this.rules.roadPermitNumber[0].required = Blen;
    //   this.rules.workCompany[0].required = Blen;
    //   this.rules.legalPerson[0].required = Blen;
    // }
    // 监听路由刷新
    $route: function(route) {
      this.checkQuire = !!this.$route.query.checkQuire;
      this.findByFieldFrom();
    }
  },
  created() {
    const partyType = this.$store.getters.party.partyType;
    this.isAdmin =
      partyType == "SUPER_ADMIN" ||
      partyType == "PLAT_ADMIN" ||
      partyType == "STAFF";
    this.checkQuire = !!this.$route.query.checkQuire;
    this.findByFieldFrom();
  },
  methods: {
    // 查询必填项
    async findByFieldFrom() {
      let response = await findByFieldFrom({ fieldFrom: "driverTeam" });
      this.requireData = response.data;
      for (let key in this.requireData) {
        if (this.rules[key])
          this.rules[key][0].required = !!this.requireData[key];
      }
    },
    // 保存必填设置
    async funcSaveSet() {
      const rLoading = this.openLoading();
      let response = await updateFieldRequired({
        message: this.requireData,
        fieldFrom: "driverTeam"
      });
      rLoading.close();
      this.$message.success(response.msg);
      this.$router.push({
        path: "/basicInfo/driver/driverTeamManage"
      });
    },
    // 设置必填
    setQuired(key) {
      this.rules[key][0].required = !!this.requireData[key];
    },
    changeAreaList(value) {
      this.form.provinceCode = value[0];
      this.form.cityCode = value[1];
      this.form.countyCode = value[2];
    },
    // 提交
    funcSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const rLoading = this.openLoading();
          addDriverTeam(this.form).then(response => {
            rLoading.close();
            this.$message({ message: response.msg, type: "success" });
            this.$refs.form.resetFields();
            this.$router.push({
              path: "/basicInfo/driver/driverTeamManage",
              query: { needRefreshDriverCompany: true }
            });
          });
        }
        // else {
        //   this.$message.error("请输入有效值!");
        // }
      });
    },
    channelInputLimit(e) {
      let key = e.key;
      // 只能输入中文、英文和·
      const reg = /[a-zA-Z\u4E00-\u9FA5·]/;
      if (!reg.test(key)) {
        e.returnValue = false;
        return false;
      }
      return true;
    },
    // 身份证正面识别
    async ficationImgSuccess(url) {
      let res = await getOcr({ image: url, ocrType: "ocrIdidentityCardFront" });
      let data = res.data;
      data.name ? this.$set(this.form, "name", data.name) : null;
      data.name ? this.$set(this.form, "legalPerson", data.name) : null;
      data.identity
        ? this.$set(this.form, "identificationNumber", data.identity)
        : null;
      data.address ? this.$set(this.form, "homeAddress", data.address) : null;
      if (data.provinceCode) {
        this.$set(this.form, "provinceCode", data.provinceCode);
        this.$set(this.form, "cityCode", data.cityCode);
        this.$set(this.form, "countyCode", data.countyCode);
        this.$set(this.form, "areaList", [
          data.provinceCode,
          data.cityCode,
          data.countyCode
        ]);
      }
    },
    // 身份证反面识别
    async ficationImgBackSuccess(url) {
      let res = await getOcr({
        image: url,
        ocrType: "ocrIdidentityCardFrontBack"
      });
      let data = res.data;
      if (data.expiryDate == "长期" || data.expiryDate == "9999-12-31") {
        this.$set(this.form, "hasDueDate", true);
        this.$set(this.form, "idCardDueDate", "9999-12-31");
      } else if (data.expiryDate) {
        let time = data.expiryDate.replace(/[^\d]/g, "");
        if (realDay(time)) {
          let expiryDate =
            time.slice(0, 4) + "-" + time.slice(4, 6) + "-" + time.slice(6);
          this.$set(this.form, "idCardDueDate", expiryDate);
          this.$set(this.form, "hasDueDate", false);
        }
      }
    },
    // 道路经营许可证识别
    async roadPermitNumberSuccess(url) {
      let res = await getOcr({ image: url, ocrType: "ocrRoadPermitNumber" });
      let data = res.data;
      data.hao ? this.$set(this.form, "roadPermitNumber", data.hao) : null;
    },
    // 社会信用识别
    async businessImgSuccess(url) {
      let res = await getOcr({ image: url, ocrType: "ocrBusinessLicense" });
      let data = res.data;
      if (data.creditNum !== "无") {
        this.$set(this.form, "businessLicenseNumber", data.creditNum);
      }
      if (data.companyName !== "无") {
        this.$set(this.form, "workCompany", data.companyName);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.el-date-editor {
  width: 100%;
}
</style>
